<div style="position: relative; min-height: 100vh">
  <app-loader></app-loader>
  <router-outlet></router-outlet>
  <!-- <div class="flex flex-row justify-between primary-100 footer-info">
    <div class="footer-info-container">
      <span>Piattaforma realizzata da CrescItalia Servizi Imprese</span>
    </div>
    <div *ngIf="displayLogoMediazione" class="footer-info-container justify-center" style="padding: 12px 0;">
      <img height="32px" src="assets/images/logo-mediazione.png" />

    </div>

    <div class="footer-info-container justify-end">
      <span class="primary-100">Versione {{version}}</span>

    </div>


  </div> -->
</div>
